/**
 * Checks if the current pathname should redirect to web.settlin.in
 * based on the old web paths that need to be preserved
 */

const EXACT_REDIRECT_PATHS = [
	"/homeloan",
	"/dashboard/seller/listByLink",
	"/dashboard/buyer/requestPropertyViaLink",
	"/bookVisitSlots",
	"/unitAction",
	"/visitConfirmation",
	"/visitConfirmationWithOtp",
	"/visitNotRequired",
	"/buyerAgreement",
	"/unsubscribe",
	"/data-deletion-request",
] as const;

export function shouldRedirectToWeb(pathname: string): boolean {
	// Check exact matches
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	if (EXACT_REDIRECT_PATHS.includes(pathname as any)) {
		return true;
	}

	// Check parameterized paths
	if (
		pathname.startsWith("/verify-email/") ||
		pathname.startsWith("/buyer-preference/") ||
		pathname.startsWith("/feedback/") ||
		pathname.startsWith("/SETLIN/bfs/") ||
		pathname.startsWith("/c/v/") ||
		pathname.startsWith("/f/s/") ||
		pathname.startsWith("/bfs/") ||
		pathname.startsWith("/ucw/") ||
		pathname.startsWith("/SETLIN/bvr/")
	) {
		return true;
	}

	return false;
}
